import GridSpinner from 'components/UI/GridSpinner'
import ShowMoreButton from 'components/ShowMoreButton'
import { List } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React from 'react'
import { useTableConfig } from 'modules/Referral/PayoutProfiles/List/subcomponents/List/hooks/useTableConfig'

const ListComponent = ({ data = [], pagination, loading, onChangePage, EmptyComponent = null }) => {
  const { tableState, tableConfig } = useTableConfig({}, data)

  return (
    <>
      {data.length === 0 && loading ? (
        <GridSpinner />
      ) : (
        <List
          table={tableState}
          config={tableConfig}
          EmptyComponent={EmptyComponent}
        />
      )}

      <ShowMoreButton
        onClick={() => onChangePage(1)}
        loading={loading}
        current={data.length}
        total={pagination.total}
      />
    </>
  )
}

ListComponent.propTypes = {
  data: PropTypes.array,
  pagination: PropTypes.object,
  loading: PropTypes.bool,
  onChangePage: PropTypes.func,
  EmptyComponent: PropTypes.elementType,
}

export default ListComponent
